export class InscribirMandatoResponse {
    constructor(
        public codret:String,
        public descret:String,
        public fectrx:String
    ){}
}